import { isEntry as isEntry$1, makeEntry as makeEntry$1 } from '../../internal/blockedRequests.esm.js';
import { make } from '../../internal/cache.esm.js';
import { map, deferredMake } from '../../internal/core.esm.js';
import { interruptWhenPossible as interruptWhenPossible$1 } from '../../internal/fiberRuntime.esm.js';
import { RequestTypeId as RequestTypeId$1, isRequest as isRequest$1, of as of$1, tagged as tagged$1, complete as complete$1, completeEffect as completeEffect$1, fail as fail$1, succeed as succeed$1, Listeners } from '../../internal/request.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const RequestTypeId = RequestTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Request<E, A>` is a request from a data source for a value of type `A`
 * that may fail with an `E`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Returns `true` if the specified value is a `Request`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isRequest = isRequest$1;

/**
 * Constructs a new `Request`.
 *
 * @since 2.0.0
 * @category constructors
 */
const of = of$1;

/**
 * Constructs a new `Request`.
 *
 * @since 2.0.0
 * @category constructors
 */
const tagged = tagged$1;

/**
 * Complete a `Request` with the specified result.
 *
 * @since 2.0.0
 * @category request completion
 */
const complete = complete$1;

/**
 * Interrupts the child effect when requests are no longer needed
 *
 * @since 2.0.0
 * @category request completion
 */
const interruptWhenPossible = interruptWhenPossible$1;

/**
 * Complete a `Request` with the specified effectful computation, failing the
 * request with the error from the effect workflow if it fails, and completing
 * the request with the value of the effect workflow if it succeeds.
 *
 * @since 2.0.0
 * @category request completion
 */
const completeEffect = completeEffect$1;

/**
 * Complete a `Request` with the specified error.
 *
 * @since 2.0.0
 * @category request completion
 */
const fail = fail$1;

/**
 * Complete a `Request` with the specified value.
 *
 * @since 2.0.0
 * @category request completion
 */
const succeed = succeed$1;

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @category models
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */
const makeCache = options => make({
  ...options,
  lookup: () => map(deferredMake(), handle => ({
    listeners: new Listeners(),
    handle
  }))
});

/**
 * @since 2.0.0
 * @category symbols
 */
const EntryTypeId = /*#__PURE__*/Symbol.for("effect/RequestBlock.Entry");

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Entry<A>` keeps track of a request of type `A` along with a
 * `Ref` containing the result of the request, existentially hiding the result
 * type. This is used internally by the library to support data sources that
 * return different result types for different requests while guaranteeing that
 * results will be of the type requested.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category guards
 */
const isEntry = isEntry$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const makeEntry = makeEntry$1;

export { EntryTypeId, RequestTypeId, complete, completeEffect, fail, interruptWhenPossible, isEntry, isRequest, makeCache, makeEntry, of, succeed, tagged };
